import React, { useState, useEffect } from "react";
import { customFetch } from '../apiClient';

const ReportDue = () => {
  const [dueList, setDueList] = useState([]);     // Full Data (Print ke liye)
  const [displayList, setDisplayList] = useState([]); // Pagination Data (Screen ke liye)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = sessionStorage.getItem("token");

  // Pagination States
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  // Current Date for Print Header
  const printDate = new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });

  // ✅ Fetch Data & Filter 0 Dues
  useEffect(() => {
    const fetchDueList = async () => {
      try {
        setLoading(true); setError(null);
        
        const res = await customFetch(`/BillingPayment/customer-due-report-sp`);

        if (!res.ok) {
          setDueList([]); setDisplayList([]); setTotalRecords(0);
          setError("Failed to load data."); return;
        }

        const data = await res.json();
        let safeData = Array.isArray(data) ? data : [];
        
        // ✅ NEW LOGIC: Filter out customers with 0 Due
        // Hum sirf wahi record rakhenge jinka due 0 nahi hai (Positive or Negative)
        safeData = safeData.filter(item => {
            const amount = Number(item.Dues || item.dues || 0);
            return amount !== 0; // Agar 0 hai toh hata do
            // Agar sirf positive due chahiye toh: return amount > 0;
        });
        
        setDueList(safeData);
        setTotalRecords(safeData.length);
        applyPagination(safeData, 1, rowsPerPage);
      } catch (e) {
        setDueList([]);
        setError("Error fetching data.");
      } finally { setLoading(false); }
    };
    fetchDueList();
  }, []); // rowsPerPage dependency hataya taaki loop na bane

  // Pagination Logic
  const applyPagination = (data, page, rows) => {
    const startIndex = (page - 1) * rows;
    const endIndex = startIndex + rows;
    setDisplayList(data.slice(startIndex, endIndex));
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (e) => {
    const value = e.target.value === '' ? '' : parseInt(e.target.value);
    setRowsPerPage(value);
    if (value && value > 0) applyPagination(dueList, 1, value);
  };

  const handlePageChange = (page) => { applyPagination(dueList, page, rowsPerPage || 10); };

  const effectiveRows = rowsPerPage || 10;
  const totalPages = Math.ceil(totalRecords / effectiveRows);

  const renderPagination = () => {
    if (!effectiveRows || totalRecords === 0) return null;
    const maxVisible = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);
    if (endPage - startPage + 1 < maxVisible) startPage = Math.max(1, endPage - maxVisible + 1);

    return (
      <div className="pagination-controls">
        <button className="btn-page" disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}><i className="bi bi-chevron-left"></i></button>
        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map(num => (
            <button key={num} className={`btn-page ${currentPage === num ? "active" : ""}`} onClick={() => handlePageChange(num)}>{num}</button>
        ))}
        <button className="btn-page" disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}><i className="bi bi-chevron-right"></i></button>
      </div>
    );
  };

  // ✅ Calculations
  const formatNumber = (num) => (typeof num === "number" ? num.toFixed(2) : "0.00");
  const totalDueSum = dueList.reduce((acc, item) => acc + (item.Dues || item.dues || 0), 0);
  const pageTotalSum = displayList.reduce((acc, item) => acc + (item.Dues || item.dues || 0), 0);

  return (
    <div className="report-due-container">
      
      {/* --- SCREEN VIEW (Card) --- */}
      <div className="report-card screen-only">
        
        {/* Header */}
        <div className="report-header">
           <div className="header-left">
             <div className="header-icon"><i className="bi bi-exclamation-triangle"></i></div>
             <div className="header-text"><h5>Customer Due Report</h5><p>View outstanding payments</p></div>
           </div>

           {/* Header Actions */}
           <div className="header-actions">
              <div className="header-input-group">
                <label>Rows:</label>
                <input 
                  type="number" 
                  className="header-input" 
                  value={rowsPerPage} 
                  onChange={handleRowsPerPageChange} 
                  min="1" max="100" 
                />
              </div>

              <button 
                  className="btn-header-action" 
                  onClick={() => window.print()}
                  disabled={dueList.length === 0}
                  title="Print All Records"
              >
                  <i className="bi bi-printer-fill"></i> Print All ({totalRecords})
              </button>
           </div>
        </div>

        <div className="card-content">
          
          {/* Info Text */}
          <div className="records-info mb-3 text-end border-bottom pb-2">
             Showing <b>{totalRecords > 0 ? ((currentPage - 1) * effectiveRows) + 1 : 0}</b> to <b>{Math.min(currentPage * effectiveRows, totalRecords)}</b> of <b>{totalRecords}</b> customers
          </div>

          {loading && <div className="text-center py-5 text-muted"><div className="spinner-border text-primary" role="status"></div><div className="mt-2">Loading data...</div></div>}
          {error && <div className="alert-custom alert-danger">{error}</div>}

          {/* Screen Table */}
          {!loading && !error && (
            <div className="table-section">
                <div className="table-responsive">
                <table className="custom-table">
                    <thead>
                    <tr>
                        <th>Customer Name</th>
                        <th>Mobile No</th>
                        <th>Address</th>
                        <th className="text-right">Total Billing</th>
                        <th className="text-right">Received</th>
                        <th className="text-right">Total Due</th>
                    </tr>
                    </thead>
                    <tbody>
                    {/* NO RECORD FOUND */}
                    {displayList.length === 0 ? (
                        <tr>
                            <td colSpan="6" className="empty-state">
                                <i className="bi bi-folder-x display-4 text-muted mb-3 d-block"></i>
                                <p className="mb-0 fw-bold text-secondary">No Due Records Found</p>
                                <small className="text-muted">All clear! No pending payments.</small>
                            </td>
                        </tr>
                    ) : (
                        displayList.map((item, idx) => (
                        <tr key={idx}>
                            <td className="fw-medium">{item.CUSTNAME || item.custname || "-"}</td>
                            <td>{item.MOBILE || item.mobile || "-"}</td>
                            <td className="text-muted small">{item.Address || item.address || "-"}</td>
                            <td className="text-right">₹{formatNumber(item.Billing || item.billing)}</td>
                            <td className="text-right text-success">₹{formatNumber(item.Received || item.received)}</td>
                            <td className={`text-right fw-bold ${(item.Dues || item.dues) > 0 ? "text-danger" : "text-success"}`}>
                            ₹{formatNumber(item.Dues || item.dues)}
                            </td>
                        </tr>
                        ))
                    )}
                    
                    {displayList.length > 0 && (
                        <tr className="row-highlight">
                        <td colSpan="5" className="text-right fw-bold">Page Total Due</td>
                        <td className="text-right fw-bold text-danger">₹{formatNumber(pageTotalSum)}</td>
                        </tr>
                    )}
                    </tbody>
                    
                    {dueList.length > 0 && (
                        <tfoot>
                        <tr className="footer-row">
                            <td colSpan="5" className="text-right">GRAND TOTAL DUE</td>
                            <td className="text-right">₹{formatNumber(totalDueSum)}</td>
                        </tr>
                        </tfoot>
                    )}
                </table>
                </div>
            </div>
          )}

          {/* Pagination */}
          {totalPages > 1 && <div className="pagination-section">{renderPagination()}</div>}

        </div>
      </div>

      {/* --- PRINT ONLY VIEW --- */}
      <div className="print-only-section">
         <div className="text-center mb-4">
             <h3 className="fw-bold mb-1">Customer Due Report</h3>
             <p className="mb-0 text-muted">Report generated on: {printDate}</p>
         </div>

         <table className="print-table">
            <thead>
                <tr>
                    <th style={{width: '5%'}}>#</th>
                    <th>Customer Name</th>
                    <th>Mobile</th>
                    <th>Address</th>
                    <th className="text-right">Billing</th>
                    <th className="text-right">Received</th>
                    <th className="text-right">Due Amount</th>
                </tr>
            </thead>
            <tbody>
                {dueList.map((item, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.CUSTNAME || item.custname}</td>
                        <td>{item.MOBILE || item.mobile}</td>
                        <td>{item.Address || item.address}</td>
                        <td className="text-right">{formatNumber(item.Billing || item.billing)}</td>
                        <td className="text-right">{formatNumber(item.Received || item.received)}</td>
                        <td className="text-right fw-bold">
                            {formatNumber(item.Dues || item.dues)}
                        </td>
                    </tr>
                ))}
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan="6" className="text-right fw-bold">GRAND TOTAL DUE</td>
                    <td className="text-right fw-bold">₹{formatNumber(totalDueSum)}</td>
                </tr>
            </tfoot>
         </table>
         
         <div className="mt-4 text-end print-footer">
             <p>Authorized Signature ________________</p>
         </div>
      </div>

     {/* ✅ CSS STYLES (COMPACT) */}
      <style jsx>{`
        *, *::before, *::after { box-sizing: border-box; }
        .report-due-container { padding: 0; font-family: system-ui, sans-serif; }
        .report-card { background: white; border-radius: 6px; box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06); border: 1px solid #e0e6ed; overflow: visible; }

        /* HEADER Styling */
        .report-header { 
            background: var(--theme-color, #0088cc); 
            padding: 6px 12px; 
            border-bottom: 2px solid rgba(0,0,0,0.1); 
            border-radius: 6px 6px 0 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .header-left { display: flex; align-items: center; gap: 8px; color: white; }
        .header-icon { width: 26px; height: 26px; background: rgba(255, 255, 255, 0.2); border-radius: 4px; display: flex; align-items: center; justify-content: center; font-size: 14px; }
        .header-text { display: flex; align-items: baseline; gap: 8px; }
        .header-text h5 { margin: 0; font-size: 13px; font-weight: 600; line-height: 1.2; }
        .header-text p { margin: 0; color: rgba(255, 255, 255, 0.85); font-size: 10px; }

        /* HEADER ACTIONS */
        .header-actions { display: flex; align-items: center; gap: 8px; }

        .btn-header-action {
            height: 26px; /* COMPACT HEIGHT */
            padding: 0 12px;
            border-radius: 4px;
            border: 1px solid rgba(255, 255, 255, 0.3);
            background: rgba(255, 255, 255, 0.15);
            color: white;
            font-size: 11px; /* COMPACT FONT */
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s ease;
            display: inline-flex;
            align-items: center;
            gap: 6px;
        }

        .btn-header-action:hover:not(:disabled) {
            background: white;
            color: var(--theme-color, #0088cc);
        }

        .btn-header-action:disabled { opacity: 0.5; cursor: not-allowed; }

        .header-input-group {
            display: flex; align-items: center; gap: 6px; color: white; font-size: 11px; font-weight: 600;
            background: rgba(255, 255, 255, 0.15); padding: 0 8px; height: 26px; border-radius: 4px; border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .header-input {
            width: 40px; height: 18px; padding: 0 4px; border-radius: 3px; border: none; text-align: center;
            font-size: 11px; outline: none; background: white; color: #333;
        }

        .card-content { padding: 10px 12px; }

        .records-info { font-size: 11px; color: #64748b; padding-bottom: 8px; margin-bottom: 10px; }

        .table-section { background: white; border-radius: 4px; border: 1px solid #e0e6ed; overflow: hidden; }
        .table-responsive { overflow-x: auto; }
        .custom-table { width: 100%; border-collapse: collapse; font-size: 11px; }
        .custom-table thead { background: #f1f5f9; border-bottom: 1px solid #cbd5e0; }
        .custom-table th { color: #2c3e50; padding: 6px 8px; text-align: left; font-weight: 600; font-size: 10px; text-transform: uppercase; white-space: nowrap; border-right: 1px solid #e0e6ed; }
        .custom-table td { padding: 4px 8px; border-bottom: 1px solid #e0e6ed; border-right: 1px solid #e0e6ed; vertical-align: middle; white-space: nowrap; }
        .custom-table td:last-child, .custom-table th:last-child { border-right: none; }
        .custom-table tr:hover { background: #f8fafc; }

        .row-highlight { background: #f0f9ff; }
        .footer-row { background: #fee2e2; color: #b91c1c; font-weight: 700; font-size: 11px; }
        .footer-row td { border-top: 1px solid #fecaca; }

        .text-right { text-align: right !important; }
        .fw-bold { font-weight: 700; }
        .text-success { color: #15803d !important; }
        .text-danger { color: #dc2626 !important; }
        .text-muted { color: #64748b !important; }
        
        .empty-state { text-align: center; padding: 20px; color: #94a3b8; }
        .empty-state i { font-size: 24px; opacity: 0.5; margin-bottom: 6px; }
        .empty-state p { font-size: 11px; }

        /* PAGINATION */
        .pagination-section { display: flex; justify-content: center; margin-top: 10px; padding-top: 10px; border-top: 1px solid #e0e6ed; }
        .pagination-controls { display: flex; gap: 4px; }
        .btn-page { width: 24px; height: 24px; border: 1px solid #cbd5e0; background: white; border-radius: 4px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 11px; transition: all 0.2s; color: #2c3e50; }
        .btn-page:hover:not(:disabled) { background: #f1f5f9; border-color: var(--theme-color, #0088cc); color: var(--theme-color, #0088cc); }
        .btn-page.active { background: var(--theme-color, #0088cc); color: white; border-color: var(--theme-color, #0088cc); }
        .btn-page:disabled { opacity: 0.5; cursor: not-allowed; background: #f8fafc; }

        .alert-custom { padding: 6px 10px; border-radius: 4px; font-size: 11px; margin-bottom: 10px; display: flex; align-items: center; gap: 6px; }
        .alert-danger { background: #fee2e2; color: #b91c1c; border: 1px solid #fecaca; }

        /* --- PRINT STYLES --- */
        .print-only-section { display: none; }

        @media print {
            body * { visibility: hidden; } 
            
            .print-only-section, .print-only-section * { visibility: visible; }
            .print-only-section { 
                display: block; 
                position: absolute; 
                top: 0; 
                left: 0; 
                width: 100%; 
                background: white;
                padding: 20px;
            }

            @page { size: A4; margin: 10mm; }
            body { margin: 0; padding: 0; }

            .print-table { width: 100%; border-collapse: collapse; font-family: 'Times New Roman', serif; font-size: 12px; color: black; }
            .print-table th { border: 1px solid black; padding: 5px; background: #f0f0f0 !important; color: black; font-weight: bold; text-align: left; -webkit-print-color-adjust: exact; }
            .print-table td { border: 1px solid black; padding: 5px; vertical-align: middle; }
            .print-table tfoot td { border: 1px solid black; font-weight: bold; background: #f0f0f0 !important; -webkit-print-color-adjust: exact; }
            
            tr { page-break-inside: avoid; }
            thead { display: table-header-group; }
            tfoot { display: table-footer-group; }

            .text-right { text-align: right !important; }
            .fw-bold { font-weight: bold !important; }
            .text-danger, .text-success { color: black !important; } 
            .print-footer { margin-top: 40px; font-size: 14px; }
        }

        @media (max-width: 768px) {
          .report-header { flex-direction: column; gap: 10px; align-items: flex-start; }
          .header-actions { width: 100%; justify-content: space-between; }
          .custom-table { min-width: 600px; }
        }
      `}</style>
    </div>
  );
};

export default ReportDue;